<template>
  <v-container>
    <div class="center-box">
      <div class="login">
        <v-layout row wrap>
          <v-flex>
            <v-layout row column>
                <img src="@/assets/images/logo-cc-tu.png" alt="Logo" class="mx-auto mb-10" width="95px">
                <div class="text-xs-center">
                  <h2 class="h3">Comfort Commodity</h2>
                  <p class="mb-30"><strong>Investiční zlato a stříbro</strong></p>
                </div>      
            </v-layout>
          </v-flex>
        </v-layout>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field hide-details solo class="ma-0 mb-10" placeholder="Uživatelské jméno" v-model="login" @keyup.native.enter="submit"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field hide-details solo class="ma-0 mb-30" placeholder="Heslo" v-model="password" :append-icon="show ? 'visibility' : 'visibility_off'" :rules="[rules.required]" :type="show ? 'text' : 'password'" counter @click:append="show = !show" @keyup.native.enter="submit">
              </v-text-field>
            </v-flex>
            <v-flex xs12 v-if="errorText != null">
              <p class="mt-2 mb-4 red--text"><strong>{{errorText}}</strong></p>
            </v-flex>
            <v-flex xs12>
              <v-btn color="orange" class="elevation-0 button button-login ma-0 mb-20" dark @click="submit" :disabled="!valid" :loading="loading">Přihlásit</v-btn>
            </v-flex>
            <v-flex xs12>
              <v-checkbox hide-details label="Zapamatovat přihlašovací údaje" class="ma-0 mb-30" color="orange"></v-checkbox>
            </v-flex>
            <v-flex xs12>
              <p class="ma-0 forget">
                <strong>Zapomněli jste heslo? <eshop-link :to="{ path: '/obnova-hesla' }">Obnova hesla ZDE</eshop-link>.</strong>
              </p>
            </v-flex>
              <v-flex xs12>
                  <p class="mt-3 register">
                      <strong>Nejste naším klientem? <external-link href="https://www.comfort-commodity.cz/eshop/">Zaregistrujte se ZDE</external-link>.</strong>
                  </p>
              </v-flex>
          </v-layout>
        </v-form>
      </div>

      <v-footer class="login-footer">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <img src="@/assets/images/logo-cc-tu.png" alt="Logo" width="95px" class="mx-auto">
            <h3 class="mb-2">Comfort Commodity</h3>
            <h4>
              <a class="link-black" href="tel:+420734232022">+420 734 232 022</a> <br>
              <a class="link-black" href="mailto:info@comfort-commodity.cz">info@comfort-commodity.cz</a></h4>
            <!-- <p class="mb-0"><strong>&copy; Comfort Commodity 2019</strong></p> -->
          </v-flex>
        </v-layout>
      </v-footer>
    </div>
  </v-container>
</template>

<script>
import {isRoutePathWithParametersExists} from "@/main";

export default {
  data () {
    return {
      show: false,
      rules: {
        required: value => !!value || 'Vyžadováno.',
        emailMatch: () => ('Email a heslo, které jste zadali není správně.')
      },
      valid: true,
      loading: false,
      passHidden: true,
      login: '',
      emailRules: [
        (v) => !!v || 'Přihlašovací jméno je vyžadováno'//,
        //(v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mailová adresa není ve správném formátu'
      ],
      password: '',
      errorText: null
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.$data.errorText = null;
        this.$data.loading = true;
        var x = 0; var y = 0;
        try {
          var win = window,
            doc = document,
            docElem = doc.documentElement,
            body = doc.getElementsByTagName('body')[0];
          x = win.innerWidth || docElem.clientWidth || body.clientWidth;
          y = win.innerHeight|| docElem.clientHeight|| body.clientHeight;
        }
        catch ($e) {

        }
        window.API.post("session/prihlasit", {
            uzivatel: this.$data.login,
            heslo: this.$data.password,
            prohlizec: window.MobileDetect.userAgent(),
            zarizeni: window.MobileDetect.tablet() ? 'tablet' : (window.MobileDetect.mobile() ? 'mobil' : 'pc'),
            os: window.MobileDetect.os(),
            rozliseni_sirka: x,
            rozliseni_vyska: y
        }).then(function(body) {
          if (body.prihlasen) {
            //window.API.$setCookie("hn_org", body.UID.toString(), { expires: 30, path: "/" });
            window.API.$setCookie("cc_eshop_uid", body.uid.toString(), { expires: 30, path: "/" });
            window.API.$setCookie("cc_eshop_token", body.token, { expires: 30, path: "/" });
            this.$emit("signed");

            let url = window.location.href.split("/#/");
            if(url.length > 1) {
              this.$router.push({path: "/"+url[1]});
            } else {
              this.$router.push({path: "/"});
            }
          }
          else {
            this.$data.errorText = 'Nebyly zadány správné přihlašovací údaje.';
          }
          this.$data.loading = false;
        }.bind(this)).catch(function(err) {
          this.$data.loading = false;
        }.bind(this));
      }
    }
  }
}
</script>
